module.exports = __webpack_public_path__ + "img/hopways-02.9a4ae013.webp";